import Link from "@mui/material/Link"

export default function ContactSupportLink({
  color = "primary.main",
  subject = "OneBase Customer Portal Support Request",
  body = "",
  label = "contact support",
}) {
  const params = new URLSearchParams()
  params.set("subject", subject)
  if (body) {
    params.set("body", body)
  }
  return (
    <Link
      href={`mailto:support@onebasecrm.com?${params.toString()}`}
      color={color}
    >
      {label}
    </Link>
  )
}
